import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

/**
 * Retry LLM narration on a completed (or failed-but-scored) audit that had AI
 * prose skipped (rate limit, timeout, provider error). Does NOT re-crawl.
 */
export function useResumeNarration(auditId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiPost<{ workflow_id: string }>(`/v1/audits/${auditId}/resume-narration`),
    onSuccess: () => {
      // Refresh the audit + issues so the UI reflects the new narrations.
      void qc.invalidateQueries({ queryKey: ['audit', auditId] });
      void qc.invalidateQueries({ queryKey: ['audit-issues', auditId] });
      void qc.invalidateQueries({ queryKey: ['audit-progress', auditId] });
    },
  });
}
